import _ from 'lodash';

import { postJson } from '@zapier/toolbox-browser-fetch';
import {
  EntityActions,
  buildEntityActions,
  buildEntityApi,
  buildEntitySelectors,
  entityStatuses,
  entityUtils,
  normalizePostError,
} from '@zapier/toolbox-redux-framework';

import type { IApi, ISelectors, IActions } from './types';

export const type = 'authentication';

const PARAMS = 'auth_fields';

export const selectors: ISelectors = buildEntitySelectors(
  type,
  (sel: ISelectors) => {
    sel.all.authEntity = _.partial(
      sel.all.findBy,
      _.partial(sel.stateItem, 'isNewAuth')
    );
    sel.formParams = _.partial(sel.dataItem, PARAMS);
    sel.redirectUrl = _.partial(sel.dataItem, 'url');
    sel.isShared = _.partial(sel.dataItem, 'is_shared');
    sel.all.anyAreSaving = _.partial(sel.all.hasAnyBy, sel.isSaving);
    sel.all.anyAreTesting = _.partial(sel.all.hasAnyBy, sel.isTesting);
    sel.all.anyAreFailures = _.partial(sel.all.hasAnyBy, sel.isFailure);
    sel.isConfirmationSending = entity =>
      sel.stateItem('confirmationStatus', entity) === entityStatuses.SAVING;
    sel.isConfirmationSent = entity =>
      sel.stateItem('confirmationStatus', entity) === entityStatuses.SUCCESS;
    sel.isConfirmationError = entity =>
      sel.stateItem('confirmationStatus', entity) === entityStatuses.FAILURE;
  }
);

export const api: IApi = buildEntityApi(
  type,
  '/api/v3/auths',
  (authApi: IApi) => {
    authApi.test = id => postJson(authApi.modelEndpoint(`/${id}/test`));
  }
);

export const actions: IActions = buildEntityActions(
  type,
  selectors,
  api,
  (authActions: IActions) => {
    authActions.updateFormParams = _.partial(
      authActions.updateEntityDataItem,
      PARAMS
    );

    authActions.test = (messages, id) => {
      return {
        ...EntityActions.fetchEntity(
          entityStatuses.TESTING,
          type,
          messages,
          id
        ),
        formatError: _.partial(normalizePostError, type, messages),
        formatSuccess: _.partial(entityUtils.formatSuccess, messages),
        promise: api.test(id),
      };
    };
  }
);
